const cards = [
  {
    image: "https://readdy.ai/api/search-image?query=Entertainment%20news%20style%20abstract%20visual%20with%20warm%20dark%20tones%2C%20dramatic%20lighting%2C%20digital%20media%20collage%20background%2C%20modern%20social%20media%20aesthetic%2C%20no%20recognizable%20faces%2C%20bold%20composition&width=600&height=400&seq=card-01-gossip&orientation=landscape",
    tag: "网红爆料",
    title: "顶流网红直播翻车名场面合集，每一个都让人笑到停不下来",
    date: "2小时前",
    views: "128.6万",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20scene%20with%20dramatic%20orange%20red%20lighting%2C%20cinematic%20composition%2C%20mysterious%20atmosphere%2C%20entertainment%20industry%20theme%2C%20no%20faces%2C%20geometric%20shapes&width=600&height=400&seq=card-02-gossip&orientation=landscape",
    tag: "娱乐圈",
    title: "某知名艺人私下言论遭曝光，工作室紧急发声明回应争议",
    date: "5小时前",
    views: "96.3万",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Urban%20night%20scene%20with%20warm%20neon%20accents%2C%20abstract%20digital%20art%20style%2C%20social%20media%20news%20vibe%2C%20dramatic%20shadow%20play%2C%20no%20people%2C%20modern%20aesthetic&width=600&height=400&seq=card-03-gossip&orientation=landscape",
    tag: "现场实拍",
    title: "某综艺录制现场突发状况，嘉宾当场翻脸全过程完整记录",
    date: "8小时前",
    views: "85.7万",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Stylized%20abstract%20digital%20composition%20with%20warm%20coral%20and%20dark%20tones%2C%20cinematic%20lighting%2C%20entertainment%20media%20theme%2C%20dramatic%20contrast%2C%20no%20faces%2C%20modern%20design&width=600&height=400&seq=card-04-gossip&orientation=landscape",
    tag: "黑料深扒",
    title: "某平台头部主播涉嫌虚假宣传，消费者维权群已经炸锅了",
    date: "12小时前",
    views: "73.2万",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Dark%20abstract%20news%20media%20background%20with%20red%20orange%20glow%2C%20dramatic%20atmosphere%2C%20digital%20art%20style%2C%20mysterious%20composition%2C%20no%20faces%2C%20warm%20undertones&width=600&height=400&seq=card-05-gossip&orientation=landscape",
    tag: "爆料视频",
    title: "素人投稿：某健身房私教骚扰女学员监控录像外泄引热议",
    date: "1天前",
    views: "62.8万",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Abstract%20cinematic%20scene%20in%20warm%20toned%20dark%20background%2C%20dynamic%20lighting%2C%20digital%20media%20theme%2C%20modern%20entertainment%20aesthetic%2C%20no%20people%2C%20geometric%20overlay&width=600&height=400&seq=card-06-gossip&orientation=landscape",
    tag: "网红动态",
    title: "某美食博主被曝后厨卫生堪忧，粉丝表示再也不敢点外卖了",
    date: "1天前",
    views: "58.4万",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Warm%20dark%20abstract%20design%20with%20dramatic%20coral%20red%20highlights%2C%20cinematic%20media%20theme%2C%20modern%20composition%2C%20entertainment%20industry%20vibe%2C%20no%20faces%2C%20bold%20colors&width=600&height=400&seq=card-07-gossip&orientation=landscape",
    tag: "吃瓜现场",
    title: "某电商大促直播间吵架名场面，主播与品牌方当场互撕",
    date: "2天前",
    views: "47.9万",
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <span className="inline-block text-xs font-medium text-accent-700 bg-accent-100 px-3 py-1 rounded-full mb-3">
              每日精选
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
              热门吃瓜
            </h2>
          </div>
          <a
            href="#index"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {cards.map((card, i) => (
            <article
              key={i}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/50 transition-colors cursor-pointer group"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 bg-primary-500 text-background-50 text-xs font-medium px-2 py-0.5 rounded-md">
                  {card.tag}
                </span>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-950/70 to-transparent p-3">
                  <div className="flex items-center gap-3 text-background-200 text-xs">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i> {card.views}
                    </span>
                    <span>{card.date}</span>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-medium text-sm md:text-base text-foreground-800 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
              </div>
            </article>
          ))}
        </div>

        {cards.length > 6 && (
          <div className="flex justify-center mt-8">
            <a
              href="#index"
              className="inline-flex items-center gap-2 bg-background-50 border border-background-300/60 hover:border-primary-300 text-foreground-700 font-medium px-5 py-2.5 rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer"
            >
              加载更多吃瓜内容 <i className="ri-arrow-down-line"></i>
            </a>
          </div>
        )}
      </div>
    </section>
  );
}